module.exports = __webpack_public_path__ + "assets/img/bejin.7f1ee318.png";